var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CardRenderer',{attrs:{"colour":'#062B80',"location":'embedded',"cards":_vm.getCards()},on:{"submit":function($event){return _vm.cardSubmit($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }